/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';

import { useParamStore } from '@ctct/awesome-feature-flags';
import { envs } from '@ctct/infrastructure-layer';

type PromoCode = string;

type PartnerPromoCodeFilterKey = 'AU' | 'NZ' | 'US' | 'UK' | 'REST';

type PartnerPromoCodeType =
  | PromoCode
  | {
      [key in PartnerPromoCodeFilterKey]?: PromoCode;
    };

interface PartnerIdToPromoCode {
  [partnerId: number]: PartnerPromoCodeType;
}

interface PartnerPromoCodesParamStore {
  partnerIdToPromoCode: PartnerIdToPromoCode;
}

// https://console.statsig.com/3Typ1PnhGx94KaGhU6T9Bb/param_stores/partner_promo_codes
export const usePartnerPromoCodesParamStore = () => {
  if (envs.isSecure()) {
    return useMemo(
      () => ({
        getPartnerIdToPromoCode: () => ({}),
      }),
      []
    );
  }

  const paramStore = useParamStore<PartnerPromoCodesParamStore>('partner_promo_codes');

  return useMemo(
    () => ({
      getPartnerIdToPromoCode: () => paramStore.get('partnerIdToPromoCode') ?? {},
    }),
    [paramStore]
  );
};

export type UsePartnerPromoCodesParamStoreReturn = ReturnType<typeof usePartnerPromoCodesParamStore>;
